export default __webpack_public_path__ + "static/media/Group_59.08cd4a59.svg";